import { Modal } from '@calendly/ui/components/modal'
import { useEffect, useState } from 'react'

import { useGetSendOptionsQuery } from 'common'
import { useRecapShare } from 'features/recaps/meeting_list/meeting_card/recap_share_context'
// EmailComposer is reused from the shipped V1 share-email flow. It lives under tracked_meetings with
// no top-level index export (the index would create an import cycle via hooks/tracked_meetings/api),
// so this deep import is intentional and the feature-imports rule is disabled for this file in
// eslint.config.mjs.
import { EmailComposer } from 'features/tracked_meetings/share/send_email/email_composer'

const defaultCalendlyEmail = {
  emailAddress: 'notifications@calendly.com',
  accessGranted: true,
  type: 'calendly',
}

const noop = () => {}

// V2 Share email modal for Recap sharing
export const EmailModal = () => {
  const {
    emailModal: { isOpen, close },
    shareModal: { open: openShareModal },
    trackedMeeting,
    share,
    shareLink: { url: shareLinkUrl },
  } = useRecapShare()

  const { data, isSuccess } = useGetSendOptionsQuery(
    { ownerType: 'users', ownerId: 'me' },
    { skip: !isOpen }
  )
  const [sendOptions, setSendOptions] = useState([defaultCalendlyEmail])

  useEffect(() => {
    if (isSuccess) {
      setSendOptions([defaultCalendlyEmail, ...data.sendOptions])
    }
  }, [isSuccess, data])

  // V2 uses separate share/email modals driven by RecapShareContext, so we only need the
  // discard-confirmation state here (not V1's currentModal/openModal view-switching).
  const [pendingAction, setPendingAction] = useState(null)
  const isConfirmationPopupOpen = pendingAction !== null
  const handleOpenConfirmationPopup = (action) => setPendingAction(action)
  const handleCloseConfirmationPopup = () => setPendingAction(null)
  const handleConfirmAction = (onClose, onBack) => {
    if (pendingAction === 'close') {
      onClose()
    } else if (pendingAction === 'back') {
      onBack()
    }
    setPendingAction(null)
  }
  const closeModal = (onClose) => onClose()

  const handleBack = () => {
    close()
    openShareModal()
  }

  return (
    <Modal isOpen={isOpen} onClose={close}>
      <EmailComposer
        includePasscode={false}
        includePublicLink={false}
        meetingUuid={trackedMeeting?.uuid}
        shareUuid={share?.uuid}
        emails={sendOptions}
        videoPageUrl={shareLinkUrl}
        onClose={close}
        onBack={handleBack}
        onShareLinkClick={noop}
        isConfirmationPopupOpen={isConfirmationPopupOpen}
        handleOpenConfirmationPopup={handleOpenConfirmationPopup}
        handleCloseConfirmationPopup={handleCloseConfirmationPopup}
        handleConfirmAction={handleConfirmAction}
        closeModal={closeModal}
        // This is to share Recap, not meant for attendees
        isAttendeeModal={false}
        attendeesFromSearchData={[]}
      />
    </Modal>
  )
}
